import { z } from 'zod';
import superjson from 'superjson';

export const schema = z.object({});

export type TimeCategoryItem = {
  id: string;
  name: string;
  color: string;
  position: number | null;
};

export type OutputType = {
  categories: TimeCategoryItem[];
};

export const getTimeCategoriesList = async (init?: RequestInit): Promise<OutputType> => {
  const result = await fetch(`/_api/time-categories/list`, {
    method: 'GET',
    credentials: 'include',
    ...init,
    headers: {
      'Content-Type': 'application/json',
      ...(init?.headers ?? {}),
    },
  });
  if (!result.ok) {
    const errorObject = superjson.parse<{ error: string }>(await result.text());
    throw new Error(errorObject.error);
  }
  return superjson.parse<OutputType>(await result.text());
};
